import { logger } from './logger';

export function generateDefaultSnapshotName(prefix?: string): string {
  try {
    // Validate and sanitize input
    const p = (prefix ?? '').trim();
    if (typeof p !== 'string') {
      logger.warn('generateDefaultSnapshotName received non-string prefix', {
        prefixType: typeof prefix,
        prefixValue: String(prefix)
      });
      return generateDefaultSnapshotName(); // Retry without prefix
    }

    const slug = (p ? p.replace(/\s+/g, '_').replace(/[^\w-_]/g, '') : 'Migration') || 'Migration';
    const d = new Date();
    const pad = (n: number) => n.toString().padStart(2, '0');
    const yyyy = d.getFullYear();
    const mm = pad(d.getMonth() + 1);
    const dd = pad(d.getDate());
    const snapshotName = `[${slug}_Snapshot_${yyyy}-${mm}-${dd}]`;

    return snapshotName;
  } catch (error) {
    const msg = error instanceof Error ? error.message : String(error);
    logger.error('Error generating snapshot name', {
      error: msg,
      prefix: String(prefix)
    });
    // Return safe default
    const d = new Date();
    const pad = (n: number) => n.toString().padStart(2, '0');
    return `[Migration_Snapshot_${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}]`;
  }
}

export default generateDefaultSnapshotName;
